import { ConfigType, TourType } from "@/types";
import { tourStatus } from "@/utils/tour/tour-status";

type CheckFunction = () => boolean;

export const shouldAvoidTourRefresh = (
  tour: TourType,
  config: ConfigType
): boolean => {
  const tourIsNotActive = () =>
    tourStatus(tour, config.accessCodeEarlyAccess || 0) !== "active";
  const allAccessCodesAvailable = () =>
    !tour.units.some(({ accessCode }) => {
      const lockboxCodesUnavailable =
        (accessCode?.code === null || accessCode?.code === undefined) &&
        accessCode?.deviceType === "lockbox";

      const bluetoothCodesUnavailable =
        accessCode?.deviceType === "bluetooth" &&
        !accessCode?.accessControlDevicePresent;

      return lockboxCodesUnavailable || bluetoothCodesUnavailable;
    });

  // If any of these reasons are "true", then we should
  // not try to refresh the tour data.
  const reasonsToAvoid: Array<CheckFunction> = [
    tourIsNotActive,
    allAccessCodesAvailable,
  ];

  return applyChecks(reasonsToAvoid);
};

const applyChecks = (checkFunctions: Array<CheckFunction>): boolean =>
  checkFunctions.some((fn) => fn());
